import { render, staticRenderFns } from "./EndPage.vue?vue&type=template&id=3d2a50ba&scoped=true"
import script from "./EndPage.vue?vue&type=script&lang=ts"
export * from "./EndPage.vue?vue&type=script&lang=ts"
import style0 from "./EndPage.vue?vue&type=style&index=0&id=3d2a50ba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a50ba",
  null
  
)

export default component.exports